import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  // External routing
  {
    path: 'autenticacao',
    loadChildren: () => import('./external/external.module').then(mod => mod.ExternalModule)
  },
  // Internal routing
  {
    path: '',
    loadChildren: () => import('./internal/internal.module').then(mod => mod.InternalModule)
  },
  // Handle not found routes
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
